import React, { useState } from "react";
import { buildEmbedSnippet, buildEmbedLines } from "../../utils/embed";
import { Info } from "lucide-react";
import CardHeading from "./CardHeading";

function CopyIconOrCheck({ copied }) {
  if (copied) {
    return (
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.4">
        <path d="M5 12.5l4.5 4.5L19 7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" strokeLinecap="round" />
    </svg>
  );
}

export default function AddToWebsiteCard({ assistant }) {
  const [copied, setCopied] = useState(false);

  // The public id is what belongs on a customer page, not the internal one.
  const publicId = assistant?.publicId || "";
  const lines = buildEmbedLines(publicId);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(buildEmbedSnippet(publicId));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard not available; ignore
    }
  };

  return (
    <section className="dash-card">
      <CardHeading
        step={1}
        tone="blue"
        title="Add Hostor to your website"
        subtitle={
          <>
            Copy and paste this code before the closing{" "}
            <code>&lt;/body&gt;</code> tag on every page you want the assistant
            to appear.
          </>
        }
      />

      <div className="install-embed-header ist-embed-header">
        <span />
        <button
          type="button"
          className="install-copy-btn"
          onClick={handleCopy}
          disabled={!publicId}
        >
          <CopyIconOrCheck copied={copied} />
          {copied ? "Copied!" : "Copy code"}
        </button>
      </div>

      <pre className="install-code ist-code">
        <code>
          {lines.map((line, i) => (
            <React.Fragment key={i}>
              {line.indent && "  "}
              {line.attr && <span className="tok-attr">{line.attr}</span>}
              {line.attr && line.value && "="}
              {line.value && (
                <span className="tok-str">&quot;{line.value}&quot;</span>
              )}
              {line.tag && <span className="tok-tag">{line.tag}</span>}
              {i < lines.length - 1 && "\n"}
            </React.Fragment>
          ))}
        </code>
      </pre>

      <div className="ist-help">
        <span className="ist-help__icon">
          <Info size={18} strokeWidth={2.1} />
        </span>
        <div className="ist-help__text">
          <strong>Need help?</strong>
          <span>
            Email us at{" "}
            <a href="mailto:support@hostor.ai">support@hostor.ai</a>
          </span>
        </div>
      </div>
    </section>
  );
}
